import adminAxios from "./adminAxios";


// ======================================================
// ⭐ PRODUCTS (ADMIN)
// ======================================================

// GET all products
export const adminGetAllProducts = () => adminAxios.get("/products/all");

// GET single product
export const adminGetProductById = (productId) =>
  adminAxios.get(`/products/${productId}`);

// CREATE product
export const adminCreateProduct = (data) =>
  adminAxios.post("/products/create", data);

// UPDATE product
export const adminUpdateProduct = (productId, data) =>
  adminAxios.put(`/products/update/${productId}`, data);

// DELETE product
export const adminDeleteProduct = (productId) =>
  adminAxios.delete(`/products/${productId}`);


// ======================================================
// ⭐ PRODUCT VARIANTS (ADMIN)
// ======================================================

// CREATE variant
export const adminCreateVariant = (productId, data) =>
  adminAxios.post(`/product-variants/create-variant/${productId}`, data);

// UPDATE variant
export const adminUpdateVariant = (variantId, data) =>
  adminAxios.put(`/product-variants/update-variant/${variantId}`, data);

// DELETE variant
export const adminDeleteVariant = (variantId) =>
  adminAxios.delete(`/product-variants/delete-variant/${variantId}`);

// GET all variants of a product
export const adminGetVariantsByProduct = (productId) =>
  adminAxios.get(`/product-variants/product/${productId}`);


// ======================================================
// ⭐ CATEGORY (ADMIN)
// ======================================================

// CREATE category
export const adminCreateCategory = (data) =>
  adminAxios.post("/categories/create", data);

// UPDATE category
export const adminUpdateCategory = (categoryId, data) =>
  adminAxios.put(`/categories/update/${categoryId}`, data);

// DELETE category
export const adminDeleteCategory = (categoryId) =>
  adminAxios.delete(`/categories/delete/${categoryId}`);

// GET single category
export const adminGetSingleCategory = (categoryId) =>
  adminAxios.get(`/categories/single/${categoryId}`);

// LIST category
export const adminListCategories = () =>
  adminAxios.get("/categories/list");


// ======================================================
// ⭐ SUBCATEGORY (ADMIN)
// ======================================================

// CREATE subcategory
export const adminCreateSubCategory = (data, config = {}) =>
  adminAxios.post("/subcategories/create", data, config);

// LIST subcategories
export const adminListSubCategories = () =>
  adminAxios.get("/subcategories/list");

// GET single subcategory
export const adminGetSingleSubCategory = (subcategoryId) =>
  adminAxios.get(`/subcategories/single/${subcategoryId}`);

// UPDATE subcategory
export const adminUpdateSubCategory = (subcategoryId, data, config = {}) =>
  adminAxios.put(`/subcategories/update/${subcategoryId}`, data, config);

// DELETE subcategory
export const adminDeleteSubCategory = (subcategoryId) =>
  adminAxios.delete(`/subcategories/delete/${subcategoryId}`);



// ======================================================
// ⭐ BANNERS (ADMIN)
// ======================================================

// GET ALL banners
export const adminGetAllBanners = () => adminAxios.get("/banners/get/all");

// CREATE banner
export const adminCreateBanner = (data) =>
  adminAxios.post("/banners/create", data);

// UPDATE banner
export const adminUpdateBanner = (bannerId, data) =>
  adminAxios.put(`/banners/update/${bannerId}`, data);

// DELETE banner
export const adminDeleteBanner = (bannerId) =>
  adminAxios.delete(`/banners/delete/${bannerId}`);


// ======================================================
// ⭐ BLOGS (ADMIN)
// ======================================================

// GET all blogs
export const adminGetAllBlogs = () => adminAxios.get("/blogs/all/blogs");

// CREATE blog
export const adminCreateBlog = (data) =>
  adminAxios.post("/blogs/create/blogs", data);

// UPDATE blog
export const adminUpdateBlog = (blogId, data) =>
  adminAxios.put(`/blogs/update/blog/${blogId}`, data);

// DELETE blog
export const adminDeleteBlog = (blogId) =>
  adminAxios.delete(`/blogs/delete/blog/${blogId}`);


// ======================================================
// ⭐ SHIPPING FEES (ADMIN)
// ======================================================

// CREATE shipping fee
export const adminCreateShippingFee = (data) =>
  adminAxios.post("/shipping-fees/admin/create", data);

// UPDATE fee
export const adminUpdateShippingFee = (feeId, data) =>
  adminAxios.put(`/shipping-fees/admin/update/${feeId}`, data);

// DELETE fee
export const adminDeleteShippingFee = (feeId) =>
  adminAxios.delete(`/shipping-fees/admin/delete/${feeId}`);

// GET all shipping fees
export const adminGetAllShippingFees = () =>
  adminAxios.get("/shipping-fees/admin/get-all");

// GET single fee
export const adminGetFeeById = (feeId) =>
  adminAxios.get(`/shipping-fees/admin/${feeId}`);

// ======================================================
// ⭐ WALLET (ADMIN)
// ======================================================

// GET all wallet transactions (ADMIN)
export const adminGetAllWalletTransactions = (params) =>
  adminAxios.get("/users/wallet/all-transactions", { params });


// ======================================================
// ⭐ USERS (ADMIN)
// ======================================================

// GET all users
export const adminGetAllUsers = () => adminAxios.get("/users/all");

// GET single user detail (including orders)
export const adminGetUserById = (userId) =>
  adminAxios.get(`/users/get/${userId}`);


// ======================================================
// ⭐ ORDERS (ADMIN)
// ======================================================

// GET all orders
export const adminGetAllOrders = () =>
  adminAxios.get("/orders/admin/all");

// GET single order details
export const adminGetOrderDetails = (orderId) =>
  adminAxios.get(`/orders/admin/${orderId}`);

// CHANGE order status
export const adminChangeOrderStatus = (orderId, data) =>
  adminAxios.post(`/orders/admin/${orderId}/change-status`, data);

// CANCEL order
export const adminCancelOrder = (orderId) =>
  adminAxios.post(`/orders/admin/${orderId}/cancel`);

// ===============================
// ADMIN LOGIN
// ===============================
export const adminLogin = (data) => {
  return adminAxios.post("/admin/login", data);
};

// ADMIN ME
export const adminMe = () => {
  return adminAxios.get("/admin/me");
};

// ======================================================
// ⭐ SUB-ADMINS (ADMIN)
// ======================================================

// CREATE sub-admin
export const adminCreateSubAdmin = (data) =>
  adminAxios.post("/subadmins/create", data);

// UPDATE sub-admin
export const adminUpdateSubAdmin = (subadminId, data) =>
  adminAxios.put(`/subadmins/update/${subadminId}`, data);

// DELETE sub-admin
export const adminDeleteSubAdmin = (subadminId) =>
  adminAxios.delete(`/subadmins/delete/${subadminId}`);

// GET single sub-admin
export const adminGetSubAdminById = (subadminId) =>
  adminAxios.get(`/subadmins/get/${subadminId}`);

// GET all sub-admins
export const adminGetAllSubAdmins = () =>
  adminAxios.get("/subadmins/getall");


// ======================================================
// ⭐ SETTINGS (ADMIN)
// ======================================================

// CREATE settings
export const adminCreateSettings = (data) =>
  adminAxios.post("/settings/create", data);

// GET settings (admin view)
export const adminGetSettings = () =>
  adminAxios.get("/settings/admin/get");

// UPDATE settings
export const adminUpdateSettings = (settingsId, data) =>
  adminAxios.put(`/settings/update/${settingsId}`, data);

// DELETE settings
export const adminDeleteSettings = (settingsId) =>
  adminAxios.delete(`/settings/delete/${settingsId}`);

// ======================================================
// ⭐ CONTACTS (ADMIN)
// ======================================================

// GET all contacts
export const adminGetAllContacts = () => adminAxios.get("/contacts/all");

// GET single contact
export const adminGetContactById = (contactId) =>
  adminAxios.get(`/contacts/${contactId}`);

// DELETE contact
export const adminDeleteContact = (contactId) =>
  adminAxios.delete(`/contacts/${contactId}`);

// ======================================================
// ⭐ DASHBOARD (ADMIN)
// ======================================================

// GET dashboard stats
export const adminGetDashboardStats = () => adminAxios.get("/admin/dashboard");
